import React, { useEffect } from 'react';
import { Qualtrics } from '@americanexpress/shared-scripts';
import PropTypes from 'prop-types';

export const getQSI = () => typeof window !== 'undefined' && window.QSI;

export const isQSILoaded = (qsi) => {
  const api = qsi?.API;
  const requiredMethods = ['load', 'unload', 'run'];
  return !!api && requiredMethods.every((method) => !!api[method]);
};

export const loadQualtrics = (qsi) => {
  const api = qsi?.API;
  api.unload();
  api.load();
  api.run();
};

export const tryToLoadQualtrics = () => {
  // eslint-disable-next-line no-console -- hack to by pass webpack stripping console.warn
  const warn = console.warn.bind(console);

  const qsi = getQSI();

  if (!isQSILoaded(qsi)) {
    warn('Qualtrics API not found');
    return;
  }

  try {
    loadQualtrics(qsi);
  } catch (error) {
    warn('Qualtrics API Failed to run', error);
  }
};

const USConsumerQualtrics = ({ delay = 5000 }) => {
  useEffect(() => {
    setTimeout(tryToLoadQualtrics, delay);
    // todo: if it fails the first time, do we try again?
  }, [delay]);

  return (
    <Qualtrics
      version="1.71.0"
      zoneId="ZN_dhZtUGWqHlUlqhT"
      sampleType="pageview"
      sampleRate={100}
    />
  );
};

USConsumerQualtrics.propTypes = {
  delay: PropTypes.number,
};

export default USConsumerQualtrics;
